import Autocomplete from './Autocomplete'

export default Autocomplete



// WEBPACK FOOTER //
// ./src/components/autocomplete/index.js